import React from "react";
import { EventDetails } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";

interface EventDetailsProps {
  blok?: EventDetails & SbBlokData;
}

const EventDetailsComponent: React.FC<EventDetailsProps> = ({ blok }) => {
  if (!blok) return null;
  const { title, description, cta_button, cta_button_link, agendas } = blok;

  return (
    <div {...storyblokEditable(blok)} className="container py-4 py-md-5">
      <div className="row justify-content-center gy-4 gy-md-0">
        <div className="col-24 col-xl-12">
          {title && <h2>{title}</h2>}
          {description && (
            <div className="lead mb-4" dangerouslySetInnerHTML={{ __html: renderRichText(description) }} />
          )}
          {cta_button && cta_button_link?.url && (
            <p className="mb-4">
              <a
                className="btn btn-lg btn-primary"
                href={cta_button_link.url}
                target="_blank"
                rel="noopener"
              >
                {cta_button}
              </a>
            </p>
          )}
        </div>
        {agendas && agendas.length > 0 && (
          <div className="col-24 col-xl-12 mx-auto">
            <h3 className="mb-3">Agenda</h3>
            <ul className="list-unstyled">
              {agendas.map((agenda) => (
                <li
                  key={agenda._uid}
                  className="mb-2 bg-light p-3 rounded-3 border-start border-primary"
                >
                  <strong className="small d-block">{agenda.time}</strong>
                  {agenda.description}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDetailsComponent;